import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9076cd78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-in-section" }
const _hoisted_2 = { class: "search-in-section__sections" }

import pCheckbox from '@/common/pCheckbox/pCheckbox.vue';
import { profileTypes } from "@/common/types/profileTypes";
import { computed, ComputedRef } from "vue";
import { useSearchStore } from "@/searchSection/store/searchStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBySection',
  setup(__props) {

const searchStore = useSearchStore()
const descriptionTypes: object = {
  1: 'Индивидуалки',
  2: 'Массажистки',
  3: 'БДСМ',
}

const profileTypesList: ComputedRef<profileTypes[]> = computed(() => {
  return Object.keys(profileTypes)
      .filter((type) => !isNaN(Number(type)))
      .map((type) => Number(type))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileTypesList.value, (type) => {
        return (_openBlock(), _createBlock(pCheckbox, {
          key: type,
          modelValue: _unref(searchStore).searchOptions.profileTypes.includes(type),
          label: descriptionTypes[type],
          "onUpdate:modelValue": ($event: any) => (_unref(searchStore).setType(type))
        }, null, 8 /* PROPS */, ["modelValue", "label", "onUpdate:modelValue"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})